"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.VisibleAvailabilityTiles = void 0;
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _styles = require("../styles");
var _InlineActions = require("./InlineActions");
var _CompactActions = require("./CompactActions");
var _Slots = require("./Slots");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const propTypes = {
  availabilities: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)((0, _propTypes.shape)({
    date: _propTypes.string.isRequired,
    href: _propTypes.string,
    time: _propTypes.string.isRequired,
    unformattedDate: _propTypes.string.isRequired
  })), (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    date: _propTypes.string.isRequired,
    count: _propTypes.number,
    unformattedDate: _propTypes.string.isRequired
  })), (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    time: _propTypes.string.isRequired,
    href: _propTypes.string,
    unformattedDate: _propTypes.string.isRequired
  }))]),
  linkTarget: _propTypes.string,
  maxAvailabilitiesToDisplay: _propTypes.number.isRequired,
  displayLinkToViewMoreAvailabilities: _propTypes.bool,
  moreAvailabilitiesLinkText: _propTypes.node,
  noAvailabilityMessage: _propTypes.node,
  onTimeSlotsClick: _propTypes.func,
  onAvailabilityTilesLoaded: _propTypes.func,
  providerId: _propTypes.number.isRequired,
  shouldDisplayAsOnMobile: _propTypes.bool,
  viewMoreBookOnlineUrl: _propTypes.string,
  onViewMoreClick: _propTypes.func,
  isAvailabilityReadOnly: _propTypes.bool,
  shouldRenderSlotsAsButtons: _propTypes.bool,
  locationName: _propTypes.string,
  slotsAriaLabel: _propTypes.func,
  slotsAriaDescribedBy: _propTypes.string,
  viewMoreAriaLabel: _propTypes.string,
  compactTiles: _propTypes.bool,
  dataTestId: _propTypes.string,
  bookingOptionsButton: (0, _propTypes.shape)({
    text: _propTypes.string.isRequired,
    onClick: _propTypes.func.isRequired,
    ariaDescribedby: _propTypes.string,
    ariaLabel: _propTypes.string,
    /**
     * Indicates the availability and type of interactive popup element.
     * For a drawer with dialog="role", this value should be "dialog"
     */
    ariaHasPopup: _propTypes.string,
    /** Identifies the element(s) whose presence are controlled by the booking options button. */
    ariaControls: _propTypes.string,
    ariaExpanded: _propTypes.bool
  }),
  availabilityCountMessage: _propTypes.func,
  /**
   * Indicates the availability and type of interactive popup element.
   * For a drawer with dialog="role", this value should be "dialog"
   */
  slotsAriaHasPopup: _propTypes.string,
  /** Identifies the element(s) whose presence are controlled by a slot button. */
  slotsAriaControls: _propTypes.string,
  slotsAriaExpanded: _propTypes.bool,
  /** Determines the minium tile width */
  tileSize: (0, _propTypes.oneOf)(['small', 'large'])
};
const defaultProps = {
  availabilities: [],
  compactTiles: false,
  displayLinkToViewMoreAvailabilities: false,
  isAvailabilityReadOnly: false,
  linkTarget: null,
  onAvailabilityTilesLoaded: () => {},
  onTimeSlotsClick: () => {},
  shouldDisplayAsOnMobile: false,
  shouldRenderSlotsAsButtons: false,
  slotsAriaLabel: () => undefined,
  tileSize: 'large'
};
const VisibleAvailabilityTiles = _ref => {
  let {
    availabilities,
    availabilityCountMessage,
    linkTarget,
    maxAvailabilitiesToDisplay,
    displayLinkToViewMoreAvailabilities,
    moreAvailabilitiesLinkText,
    noAvailabilityMessage,
    onTimeSlotsClick,
    onAvailabilityTilesLoaded,
    providerId,
    shouldDisplayAsOnMobile,
    viewMoreBookOnlineUrl,
    onViewMoreClick,
    isAvailabilityReadOnly,
    shouldRenderSlotsAsButtons,
    locationName,
    slotsAriaLabel,
    slotsAriaDescribedBy,
    slotsAriaHasPopup,
    slotsAriaControls,
    slotsAriaExpanded,
    viewMoreAriaLabel,
    compactTiles,
    dataTestId,
    bookingOptionsButton,
    tileSize
  } = _ref;
  const slotsData = (0, _slice.default)(availabilities).call(availabilities, 0, maxAvailabilitiesToDisplay);
  (0, _react.useEffect)(() => {
    onAvailabilityTilesLoaded && onAvailabilityTilesLoaded(slotsData, providerId);
  }, [onAvailabilityTilesLoaded, providerId, slotsData]);
  const SlotsContainer = compactTiles ? _styles.CompactTilesContainer : _styles.FlexContainer;
  let Slots = _Slots.InlineSlots;
  if (isAvailabilityReadOnly) {
    Slots = _Slots.ReadOnlySlots;
  } else if (compactTiles) {
    Slots = _Slots.CompactSlots;
  }
  const slotsExist = slotsData && slotsData.length > 0;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(SlotsContainer, {
    "data-testid": dataTestId || 'AvailabilityTiles__Visible',
    justifyContent: slotsData.length ? 'flex-start' : 'center',
    shouldDisplayAsOnMobile: shouldDisplayAsOnMobile,
    tileSize: tileSize
  }, !slotsExist && /*#__PURE__*/_react.default.createElement(_styles.NoAvailabilityMessage, null, noAvailabilityMessage), slotsExist && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Slots, {
    linkTarget: linkTarget,
    onTimeSlotsClick: onTimeSlotsClick,
    providerId: providerId,
    shouldRenderSlotsAsButtons: shouldRenderSlotsAsButtons,
    shouldDisplayAsOnMobile: shouldDisplayAsOnMobile,
    slotsData: slotsData,
    locationName: locationName,
    slotsAriaLabel: slotsAriaLabel,
    slotsAriaDescribedBy: slotsAriaDescribedBy,
    slotsAriaHasPopup: slotsAriaHasPopup,
    slotsAriaControls: slotsAriaControls,
    slotsAriaExpanded: slotsAriaExpanded,
    availabilityCountMessage: availabilityCountMessage,
    tileSize: tileSize
  }), !isAvailabilityReadOnly && !compactTiles && /*#__PURE__*/_react.default.createElement(_InlineActions.InlineActions, {
    displayLinkToViewMoreAvailabilities: displayLinkToViewMoreAvailabilities,
    linkTarget: linkTarget,
    moreAvailabilitiesLinkText: moreAvailabilitiesLinkText,
    onViewMoreClick: onViewMoreClick,
    providerId: providerId,
    shouldDisplayAsOnMobile: shouldDisplayAsOnMobile,
    shouldRenderSlotsAsButtons: shouldRenderSlotsAsButtons,
    viewMoreAriaLabel: viewMoreAriaLabel,
    viewMoreBookOnlineUrl: viewMoreBookOnlineUrl
  }), !isAvailabilityReadOnly && compactTiles && /*#__PURE__*/_react.default.createElement(_CompactActions.CompactActions, {
    bookingOptionsButton: bookingOptionsButton,
    displayLinkToViewMoreAvailabilities: displayLinkToViewMoreAvailabilities,
    linkTarget: linkTarget,
    moreAvailabilitiesLinkText: moreAvailabilitiesLinkText,
    onViewMoreClick: onViewMoreClick,
    providerId: providerId,
    viewMoreAriaLabel: viewMoreAriaLabel,
    viewMoreBookOnlineUrl: viewMoreBookOnlineUrl,
    shouldRenderSlotsAsButtons: shouldRenderSlotsAsButtons
  }))));
};
exports.VisibleAvailabilityTiles = VisibleAvailabilityTiles;
VisibleAvailabilityTiles.defaultProps = defaultProps;
VisibleAvailabilityTiles.propTypes = propTypes;
VisibleAvailabilityTiles.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "VisibleAvailabilityTiles",
  "props": {
    "availabilities": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "arrayOf",
          "value": {
            "name": "shape",
            "value": {
              "date": {
                "name": "string",
                "required": true
              },
              "href": {
                "name": "string",
                "required": false
              },
              "time": {
                "name": "string",
                "required": true
              },
              "unformattedDate": {
                "name": "string",
                "required": true
              }
            }
          }
        }, {
          "name": "arrayOf",
          "value": {
            "name": "shape",
            "value": {
              "date": {
                "name": "string",
                "required": true
              },
              "count": {
                "name": "number",
                "required": false
              },
              "unformattedDate": {
                "name": "string",
                "required": true
              }
            }
          }
        }, {
          "name": "arrayOf",
          "value": {
            "name": "shape",
            "value": {
              "time": {
                "name": "string",
                "required": true
              },
              "href": {
                "name": "string",
                "required": false
              },
              "unformattedDate": {
                "name": "string",
                "required": true
              }
            }
          }
        }]
      },
      "required": false
    },
    "compactTiles": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "displayLinkToViewMoreAvailabilities": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "isAvailabilityReadOnly": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "linkTarget": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "onAvailabilityTilesLoaded": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onTimeSlotsClick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "shouldDisplayAsOnMobile": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "shouldRenderSlotsAsButtons": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "slotsAriaLabel": {
      "defaultValue": {
        "value": "() => undefined",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "tileSize": {
      "defaultValue": {
        "value": "'large'",
        "computed": false
      },
      "description": "Determines the minium tile width",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'small'",
          "computed": false
        }, {
          "value": "'large'",
          "computed": false
        }]
      },
      "required": false
    },
    "maxAvailabilitiesToDisplay": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "moreAvailabilitiesLinkText": {
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "noAvailabilityMessage": {
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "providerId": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "viewMoreBookOnlineUrl": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "onViewMoreClick": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "locationName": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "slotsAriaDescribedBy": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "viewMoreAriaLabel": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "dataTestId": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "bookingOptionsButton": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "text": {
            "name": "string",
            "required": true
          },
          "onClick": {
            "name": "func",
            "required": true
          },
          "ariaDescribedby": {
            "name": "string",
            "required": false
          },
          "ariaLabel": {
            "name": "string",
            "required": false
          },
          "ariaHasPopup": {
            "name": "string",
            "description": "Indicates the availability and type of interactive popup element.\nFor a drawer with dialog=\"role\", this value should be \"dialog\"",
            "required": false
          },
          "ariaControls": {
            "name": "string",
            "description": "Identifies the element(s) whose presence are controlled by the booking options button.",
            "required": false
          },
          "ariaExpanded": {
            "name": "bool",
            "required": false
          }
        }
      },
      "required": false
    },
    "availabilityCountMessage": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "slotsAriaHasPopup": {
      "description": "Indicates the availability and type of interactive popup element.\nFor a drawer with dialog=\"role\", this value should be \"dialog\"",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "slotsAriaControls": {
      "description": "Identifies the element(s) whose presence are controlled by a slot button.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "slotsAriaExpanded": {
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    }
  }
};